export const bookData = {
  catalyst: {
    title: "Catalyst",
    series: "The Altered",
    status: 'published',
    marketingCopyUrl: '/marketing/aboutcatalyst.txt',  
    sampleChapterUrl: '/samples/catalysttext.txt',
    imageUrl: "/images/catalystimage.jpg",
    audioFiles: [
      { title: "Chapter 1", url: "/audio/catalystaudio1.mp3" },
      { title: "Chapter 2", url: "/audio/catalystaudio2.mp3" },
      { title: "Chapter 3", url: "/audio/catalystaudio3.mp3" },
    ],
    buyLinks: {
      ebook: [
        { store: "Amazon Kindle", url: "https://www.amazon.com/dp/B0DBM144DJ" },
        { store: "Apple Books", url: "https://books.apple.com/geo/book/catalyst/id6587551830" },
        { store: "Barnes & Noble Nook", url: "https://www.barnesandnoble.com/w/catalyst-blou-bryant/1146068835?ean=2940180402356" },
        { store: "Kobo", url: "https://www.kobo.com/en/ebook/catalyst-154" },
        { store: "Google Play", url: "https://play.google.com/store/books/details?id=MZX7EAAAQBAJ" },
        // Add more ebook stores here...
      ],
      audiobook: [
        { store: "Kobo", url: "https://www.kobo.com/en/ebook/catalyst-154" },
        { store: "Google Play", url: "https://play.google.com/store/audiobooks/details?id=AQAAAEAyfi0-DM" },
      ],
       paperback: [
        { store: "Amazon", url: "https://www.amazon.com/dp/B0DBM144DJ" },
      ]
    },
    isbn: "", // Add ISBN if available
    publicationDate: "2024", // Add publication year
  },
  betrayal: {
    title: "Betrayal",
    series: "The Altered",
    status: 'published',
    marketingCopyUrl: '/marketing/aboutbetrayal.txt',  
    sampleChapterUrl: '/samples/betrayaltext.txt',
    imageUrl: "/images/betrayalimage.jpg",
    audioFiles: [
      { title: "Chapter 1", url: "/audio/betrayalaudio1.mp3" },
      { title: "Chapter 2", url: "/audio/betrayalaudio2.mp3" },
      { title: "Chapter 3", url: "/audio/betrayalaudio3.mp3" },
    ],
    buyLinks: {
      ebook: [
        { store: "Amazon Kindle", url: "https://www.amazon.com/dp/B0DBLXQRBY" },
        { store: "Apple Books", url: "https://books.apple.com/geo/book/betrayal/id6587551919" },
        { store: "Barnes & Noble Nook", url: "https://www.barnesandnoble.com/w/betrayal-blou-bryant/1134850053?ean=2940180087126" },
        { store: "Kobo", url: "https://www.kobo.com/en/ebook/betrayal-337" },
        { store: "Google Play", url: "https://play.google.com/store/books/details?id=56ITEQAAQBAJ" },
        // Add more ebook stores here...
      ],
      audiobook: [
        { store: "Kobo", url: "https://www.kobo.com/en/ebook/betrayal-337" },
        { store: "Google Play", url: "https://play.google.com/store/audiobooks/details?id=AQAAAEAybgEuIM" },
      ],
      paperback: [
        { store: "Amazon", url: "https://www.amazon.com/dp/B0DBLXQRBY" },
      ]
    },
    isbn: "", // Add ISBN if available
    publicationDate: "2024", // Add publication year
  },
  revolution: {
    title: "Revolution",
    series: "The Altered",
    status: 'published',
    marketingCopyUrl: '/marketing/aboutrevolution.txt',
    sampleChapterUrl: '/samples/revolutiontext.txt',
    imageUrl: "/images/revolutionimage.jpg",
    audioFiles: [
      { title: "Chapter 1", url: "/audio/revolutionaudio1.mp3" },
      { title: "Chapter 2", url: "/audio/revolutionaudio2.mp3" },
      { title: "Chapter 3", url: "/audio/revolutionaudio3.mp3" },
    ],
    buyLinks: {
        ebook: [
          { store: "Amazon Kindle", url: "https://www.amazon.com/dp/B0DBJRPCQB" },
          { store: "Apple Books", url: "https://books.apple.com/geo/book/revolution/id6587552011" },
          { store: "Barnes & Noble Nook", url: "https://www.barnesandnoble.com/w/revolution-blou-bryant/1146068839?ean=2940180255105" },
          { store: "Kobo", url: "https://www.kobo.com/en/ebook/revolution-225" },
          { store: "Google Play", url: "https://play.google.com/store/books/details?id=YckVEQAAQBAJ" },
          // Add more ebook stores here...
        ],
        audiobook: [
          { store: "Kobo", url: "https://www.kobo.com/en/ebook/revolution-225" },
          { store: "Google Play", url: "https://play.google.com/store/audiobooks/details?id=AQAAAEAygQDBIM" },
        ],
       paperback: [
          { store: "Amazon", url: "https://www.amazon.com/dp/B0DBJRPCQB" },
      ]
    },
    isbn: "", // Add ISBN if available
    publicationDate: "2024", // Add publication year
  },
  
  fromAway: {
    title: "From Away",
    series: "Garrett Gideon and the From Away Crew", // or the appropriate series name if applicable
    status: 'unpublished',
    marketingCopyUrl: '/marketing/aboutfromaway.txt',
    sampleChapterUrl: "/samples/fromaway.txt",
    expectedPublicationDate: "2025", // Add expected publication year if known
  },
  disordered: {
    title: "Disordered",
    series: "To be determined.", // or the appropriate series name if applicable
    status: 'unpublished',
    marketingCopyUrl: '/marketing/aboutdisordered.txt',
    sampleChapterUrl: "/samples/disordered.txt",
    expectedPublicationDate: "2025", // Add expected publication year if known
  }
};